module.exports = __webpack_public_path__ + "static/screenshot-content-b348cd71e1b4074b289195c65db71e24.png";